import { render, staticRenderFns } from "./AllCompanies.vue?vue&type=template&id=5753c4f8&scoped=true"
import script from "./AllCompanies.vue?vue&type=script&lang=js"
export * from "./AllCompanies.vue?vue&type=script&lang=js"
import style0 from "./AllCompanies.vue?vue&type=style&index=0&id=5753c4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753c4f8",
  null
  
)

export default component.exports